// extracted by mini-css-extract-plugin
export default {"content":"ProjectRumblePage_content__Wbwve","image":"ProjectRumblePage_image__uUmgO","featuresList":"ProjectRumblePage_featuresList__GnWkw"};